export enum EStatisticsUserRoles {
  UserCodeUK = 'SOAPE2P',
}

export enum EStatisticsOrderChannel {
  MultipleOrder = 'CGMO',
  SingleOrder = 'CGSO',
}

export enum EStatisticsOrderType {
  Create = 'C',
  Modify = 'M',
}
